import axios from "axios";
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Backdrop,
  CircularProgress,
  Button,
  Dialog,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Slide,
  Box,
  Grid
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Container } from "react-bootstrap";
import axiosInstance from "../../../utils/axiosInterceptor";
import NavBar from "../../marginals/navBar";
import BankDetailsPopUp from "./bankDetailsPopUp";
import BillDetailsPopUp from "./billDetailsPopUp";
import "../../utils/css/infromationRequired.css";
import MobileSecurityFooter from "../../customFiles/MobileSecurityFooter";
import SuccessClaim from "../claimForms/successPage";
import constants from "../../../config/constants.json";
import { getFormName } from "../../utils/constants/constants";
import { getCustomerSupportEmailId } from "../../../utils/constants";
import { trackEvent } from "../../../config/eventHandlers";
import { ScreenName } from "../../../config/constants";
import { isMobile } from "../../utils/miscutils";
import { formatDate } from "../../utils/miscutils";
import { isWebView } from "../../utils/deviceUtils";
import { useTaskDeviceBridge } from "@docsapp/native-wizard-sa/src/lib/useTaskDeviceBridge";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { getMbServerToken } from "../../../utils/cookieUtils";

const workflowStatusCodes = constants.workflowStatusCodes;
const decisionRoles = constants.decisionRoles;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function InformationRequired(props) {
  const page = "Information Required";
  const { claimId } = useParams();
  let apiUrl = process.env.REACT_APP_REIMBURSEMENT_URL;
   let userLongToken = getMbServerToken()
    ? getMbServerToken().trim()
    : "";

  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState();
  const [claimReportData, setClaimReportData] = useState();
  const [bankOpen, setBankOpen] = useState(false);
  const [billOpen, setBillOpen] = useState(false);
  const [billIndex, setBillIndex] = useState();
  const [apiFailure, setApiFailure] = useState();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [claimSubmitted, setClaimSubmitted] = useState(false);
  const navigate = useNavigate();

  const taskDeviceBridge = useTaskDeviceBridge();

  const bankSectionOpen = () => {
    setBankOpen(true);
  };

  const bankSectionClose = async () => {
    setBankOpen(false);
    await infoNeededClaimDetails(userLongToken);
  };

  const billSectionOpen = (index) => {
    setBillOpen(true);
    setBillIndex(index);
  };

  const billSectionClose = async () => {
    setBillOpen(false);
    await infoNeededClaimDetails(userLongToken);
  };

  const reSubmitClaim = async () => {
    setIsSubmitting(true);
    let claimStatusChangeResponse;

    let body = {
      claimid: claimId,
      remarks: "resubmitted",
      newStatus: workflowStatusCodes.claim.resubmitted,
      role: decisionRoles.frontend,
      modifiedby: claimReportData.claimRecord[0].emailid,
    };

    try {
      claimStatusChangeResponse = await axiosInstance.post(
        `${apiUrl}/admin/claimstatuschange`,
        body,
        {
          headers: {
            authtoken: userLongToken,
          },
        }
      );
      if (claimStatusChangeResponse?.data?.isSuccess) {
        setIsSubmitting(false);
        setApiFailure();
        if (claimStatusChangeResponse.data.isSuccess === true) {
          trackEvent.resubmitClaimSaveClick({
            screenName: ScreenName.INFORMATION_REQUIRED,
            claim_id: claimId,
          });
          setClaimSubmitted(true);
        }
        return claimStatusChangeResponse.data.isSuccess;
      } else {
        setIsSubmitting(false);
        setApiFailure("Failed to submit the claim try again");
        return false;
      }
    } catch (error) {
      setIsSubmitting(false);
      if (error.response.data.message === "Token_Expired")
        setApiFailure("Session expired please login again");
      else setApiFailure("Failed to submit the claim try again");
      return false;
    }
  };

  const infoNeededClaimDetails = async (userLongToken) => {
    setLoading(true);
    setClaimReportData();
    const infoNeededHeaders = {
      headers: {
        authtoken: userLongToken,
      },
    };

    const infoNeededBody = {
      claimid: claimId,
    };

    try {
      const claimReport = await axiosInstance.post(
        `${apiUrl}/claimDetails/informationNeeded`,
        infoNeededBody,
        infoNeededHeaders
      );

      if (claimReport.status === 201) {
        if (claimReport.data.isSuccess === true) {
          setClaimReportData(claimReport.data.result);
          setLoading(false);
        } else if (claimReport.data.isSuccess === false) {
          setLoading(false);
          setMessage("Unable to Fetch Claim Details");
        } else {
          setLoading(false);
          setMessage("Unable to Fetch Claim Details");
        }
      }
    } catch (error) {
      setLoading(false);
      if (error.response.data.message === "Token_Expired")
        setMessage("Session expired please login again");
      else setMessage("Unable to fetch your claims");
    }
  };

  useEffect(() => {
    infoNeededClaimDetails(userLongToken);
  }, []);

  const viewFile = async (url) => {
    if (isWebView()) {
      let request = {
        fileUrl: url,
      };
      try {
        await taskDeviceBridge.showFileViewer(request);
      } catch (error) {
        console.error(error);
      }
    } else {
      window.open(url, "_blank");
    }
  };

  return (
    <main>
      {claimSubmitted ? (
        <SuccessClaim message={"resubmitted"} claimId={claimId} />
      ) : (
        <>
          <NavBar page={page} redirect={"/"} userName={props.userName} />
          <Container>
            {!isMobile(window.innerWidth) && claimReportData && !billOpen && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "16px",
                  marginTop: "20px",
                  marginBottom: "20px",
                }}
              >
                <button
                  onClick={() => navigate(-1)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "12px",
                    border: "1px solid #A4B0C0",
                    borderRadius: "8px",
                    backgroundColor: "#FFFFFF",
                    cursor: "pointer",
                    minWidth: "48px",
                    height: "48px",
                    boxShadow: "0 1px 2px 0 rgba(23, 27, 34, 0.05)",
                  }}
                  aria-label="Go back"
                >
                  <ArrowBackIcon sx={{ color: "#141B34", fontSize: "20px" }} />
                </button>

                <div>
                  <h1
                    tabIndex={"0"}
                    style={{
                      fontSize: "1.4rem",
                      fontWeight: 600,
                      color: "#252D38",
                      margin: "0 0 4px 0",
                    }}
                  >
                    Claim ID: {claimReportData.claimRecord[0].claimid}
                  </h1>
                  <p
                    tabIndex={"0"}
                    style={{
                      fontSize: "1rem",
                      fontWeight: 300,
                      color: "#47566A",
                      margin: 0,
                    }}
                  >
                    Created on{" "}
                    {formatDate(claimReportData.claimRecord[0].createddate)}
                  </p>
                </div>
              </div>
            )}
            {claimReportData ? (
              <Container>
                {billOpen ? (
                  <BillDetailsPopUp
                    key={billIndex}
                    closeHandler={billSectionClose}
                    billIndex={billIndex}
                    billDetails={claimReportData.billRecord[billIndex]}
                    documentDetails={
                      claimReportData.claimDocumentsRecord[billIndex]
                    }
                    empId={claimReportData.claimRecord[0].employeeid}
                    entityId={claimReportData.claimRecord[0].entityid}
                    billFileTypes={claimReportData.billFileTypes[billIndex]}
                    accessToken={userLongToken}
                    patientName={claimReportData?.claimRecord?.[0]?.name}
                  />
                ) : (
                  <>
                    <div>
                      <br />
                      <h2
                        tabIndex={"0"}
                        className="margin"
                        style={{
                          fontSize: "1.25rem",
                          fontWeight: 500,
                          color: "#252D38",
                          marginBottom: "20px",
                        }}
                      >
                        Claim Details
                      </h2>
                      <div>
                        <div className="grid-container claim-details">
                          <p tabIndex={"0"}>Claim id:</p>
                          <p tabIndex={"0"}>
                            {claimReportData.claimRecord[0].claimid}
                          </p>
                          <p tabIndex={"0"}>UTR Number:</p>
                          <p tabIndex={"0"}>
                            {claimReportData.claimRecord[0].utr || "N/A"}
                          </p>
                          <p tabIndex={"0"}>Claim Amount:</p>
                          <p tabIndex={"0"}>
                            ₹{claimReportData?.claimRecord[0]?.claimamount}.00
                          </p>
                          <p tabIndex={"0"}>Claim Status:</p>
                          <p
                            tabIndex={"0"}
                            style={{
                              fontSize: "1rem",
                              fontWeight: 400,
                              color: "#AB5200",
                            }}
                          >
                            Information Required
                          </p>
                        </div>
                      </div>
                      <br />
                      <div
                        className="Notes"
                        style={{
                          marginBottom: "20px",
                          marginTop: isMobile(window.innerWidth)
                            ? "8px"
                            : "0px",
                        }}
                      >
                        <h2
                          tabIndex={0}
                          style={{ fontSize: "1.25rem", fontWeight: 500 }}
                        >
                          Note:
                        </h2>
                        <ul className="billNotes">
                          <li tabIndex={0} className="note-list">
                            Please review the rejection reasons and resubmit the
                            details correctly for the rejected bills/bank
                            account
                          </li>
                          <li tabIndex={0} className="note-list">
                            In case you do not have necessary proof for one of
                            the bills and would wish to avail partial
                            reimbursement, please reach out to us at{" "}
                            {getCustomerSupportEmailId()}
                          </li>
                        </ul>
                      </div>
                      <div className="line" />
                      <br />
                      {claimReportData.oldBankRecord.length > 0 ? (
                        <>
                          <h2
                            tabIndex={"0"}
                            style={{
                              fontSize: "1.25rem",
                              fontWeight: 500,
                              color: "#252D38",
                              marginBottom: "1.2rem",
                            }}
                          >
                            Bank Account Details
                          </h2>
                          <div
                            style={{
                              position: "relative",
                              border: "1px solid #DBE0E6",
                              borderRadius: "16px",
                              padding: "12px",
                              backgroundColor: "#ffffff",
                              boxShadow: "rgba(0, 0, 0, 0.1) 0px 1px 2px",
                            }}
                          >
                            <div className="grid-container claim-details">
                              <p tabIndex={"0"}>Account No:</p>
                              <p tabIndex={"0"}>
                                {
                                  claimReportData.oldBankRecord[0]
                                    .accountholdernumber
                                }
                              </p>

                              <p tabIndex={"0"}>Account Name:</p>
                              <p tabIndex={"0"}>
                                {
                                  claimReportData.oldBankRecord[0]
                                    .accountholdername ||
                                  claimReportData.oldBankRecord[0]
                                    .benef_name_bank_returned
                                }
                              </p>

                              {claimReportData.oldBankRecord[0].bankDocURL && (
                                <>
                                  <p tabIndex={"0"}>Bank Document:</p>
                                  <p
                                    tabIndex={"0"}
                                    style={{
                                      fontSize: "1rem",
                                      fontWeight: 400,
                                      color: "#004FB6",
                                      textDecoration: "none",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      viewFile(
                                        claimReportData.oldBankRecord[0].bankDocURL
                                      )
                                    }
                                  >
                                    View
                                  </p>
                                </>
                              )}
                            </div>

                            <div
                              style={{
                                marginTop: "10px",
                                display: "flex",
                                flexDirection: isMobile(window.innerWidth)
                                  ? "column"
                                  : "row",
                                justifyContent: "space-between",
                                alignItems: isMobile(window.innerWidth)
                                  ? "flex-start"
                                  : "center",
                              }}
                            >
                              <div
                                style={{
                                  maxWidth: isMobile(window.innerWidth)
                                    ? "100%"
                                    : "65%",
                                  minWidth: 0,
                                }}
                              >
                                <p
                                  style={{
                                    fontSize: "1rem",
                                    fontWeight: 500,
                                    color: "#AE0006",
                                    marginBottom: "8px",
                                  }}
                                >
                                  Claim On-Hold Reason
                                </p>
                                <p
                                  style={{
                                    fontSize: "1rem",
                                    fontWeight: 400,
                                    color: "#252D38",
                                    overflowWrap: "break-word",
                                    wordBreak: "break-word",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {claimReportData.oldBankRecord[0].remarks}
                                </p>
                              </div>

                              <Button
                                variant="contained"
                                color="primary"
                                onClick={bankSectionOpen}
                                sx={{
                                  backgroundColor: "#0066DC",
                                  borderRadius: "8px",
                                  minWidth: { sm: "200px", xs: "100%" },
                                  textTransform: "none",
                                  float: "right",
                                  fontSize: "1rem",
                                  color: "#fff",
                                }}
                              >
                                Re-Submit Bank Details/Docs
                              </Button>
                            </div>
                          </div>
                          <br />
                        </>
                      ) : (
                        <>
                          {claimReportData.updatedBankRecord.length > 0 ? (
                            <>
                              <h2
                                tabIndex={"0"}
                                style={{
                                  fontSize: "1.25rem",
                                  fontWeight: 500,
                                  color: "#252D38",
                                  marginBottom: "1.2rem",
                                }}
                              >
                                Bank Account Details
                              </h2>
                              <div
                                style={{
                                  position: "relative",
                                  border: "1px solid #DBE0E6",
                                  borderRadius: "16px",
                                  padding: "12px",
                                  backgroundColor: "#ffffff",
                                  boxShadow: "rgba(0, 0, 0, 0.1) 0px 1px 2px",
                                }}
                              >
                                <div
                                  className="bill-status-badge"
                                  style={{
                                    backgroundColor: "#FAFAFF",
                                    color: "#5E40AD",
                                  }}
                                >
                                  Bank Details Updated
                                </div>
                                <div
                                  className="grid-container claim-details"
                                  style={{ paddingTop: "32px" }}
                                >
                                  <p tabIndex={"0"}>Account No:</p>
                                  <p tabIndex={"0"}>
                                    {
                                      claimReportData.updatedBankRecord[0]
                                        .accountholdernumber
                                    }
                                  </p>

                                  <p tabIndex={"0"}>Account Name:</p>
                                  <p tabIndex={"0"}>
                                    {
                                      claimReportData.updatedBankRecord[0]
                                        .accountholdername
                                    }
                                  </p>

                                  <p tabIndex={"0"}>Bank Name:</p>
                                  <p tabIndex={"0"}>
                                    {
                                      claimReportData.updatedBankRecord[0]
                                        .bankname
                                    }
                                  </p>

                                  {claimReportData.updatedBankRecord[0].bankDocURL && (
                                    <>
                                      <p tabIndex={"0"}>Bank Document:</p>
                                      <p
                                        tabIndex={"0"}
                                        style={{
                                          fontSize: "1rem",
                                          fontWeight: 400,
                                          color: "#004FB6",
                                          textDecoration: "none",
                                          cursor: "pointer",
                                        }}
                                        onClick={() =>
                                          viewFile(
                                            claimReportData.updatedBankRecord[0]
                                              .bankDocURL
                                          )
                                        }
                                      >
                                        View
                                      </p>
                                    </>
                                  )}
                                </div>
                              </div>
                              <br />
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      )}

                      <Dialog
                        fullScreen
                        open={bankOpen}
                        onClose={bankSectionClose}
                        TransitionComponent={Transition}
                      >
                        <AppBar
                          sx={{
                            position: "relative",
                            backgroundColor: "#0066DC",
                          }}
                        >
                          <Toolbar>
                            <IconButton
                              edge="start"
                              color="inherit"
                              onClick={bankSectionClose}
                              aria-label="close"
                            >
                              <CloseIcon />
                            </IconButton>
                            <Typography
                              sx={{ ml: 2, flex: 1 }}
                              variant="h6"
                              component="div"
                            >
                              Update / Edit Bank account details
                            </Typography>
                          </Toolbar>
                        </AppBar>
                        <br />
                        <BankDetailsPopUp
                          closeHandler={bankSectionClose}
                          claimId={claimId}
                          bankDetails={claimReportData.oldBankRecord[0]}
                          accessToken={userLongToken}
                          entityId={claimReportData.claimRecord[0].entityid}
                        />
                      </Dialog>

                      {claimReportData.billRecord.length > 0 ? (
                        claimReportData.billRecord.map((row, idx) => (
                          <div key={idx}>
                            <h2
                              tabIndex={0}
                              style={{
                                fontSize: "1.25rem",
                                fontWeight: 500,
                                color: "#252D38",
                                marginBottom: "1.2rem",
                                overflowWrap: "break-word",
                              }}
                            >
                              {getFormName(row.category)} Bill Details
                            </h2>
                            <div
                              style={{
                                position: "relative",
                                border: "1px solid #DBE0E6",
                                borderRadius: "16px",
                                padding: "12px",
                                backgroundColor: "#ffffff",
                                boxShadow: "rgba(0, 0, 0, 0.1) 0px 1px 2px",
                              }}
                            >
                              <div className="grid-container claim-details">
                                <p tabIndex={"0"}>Bill No:</p>
                                <p tabIndex={"0"}>{row.billnumber}</p>

                                <p tabIndex={"0"}>Bill Date:</p>
                                <p tabIndex={"0"}>{row.billdate}</p>

                                <p tabIndex={"0"}>Bill Amount:</p>
                                <p tabIndex={"0"}>₹{row.billamount}.00</p>

                                <p tabIndex={"0"}>Hospital Name:</p>
                                <p tabIndex={"0"}>
                                  {row.hospitalname || "N/A"}
                                </p>
                              </div>
                              <div
                                className="line"
                                style={{ marginTop: "10px" }}
                              ></div>
                              <br />
                              <div
                                style={{
                                  marginTop: "10px",
                                  display: "flex",
                                  flexDirection: isMobile(window.innerWidth)
                                    ? "column"
                                    : "row",
                                  justifyContent: "space-between",
                                  alignItems: isMobile(window.innerWidth)
                                    ? "flex-start"
                                    : "center",
                                }}
                              >
                                <div
                                  style={{
                                    maxWidth: isMobile(window.innerWidth)
                                      ? "100%"
                                      : "65%",
                                    minWidth: 0,
                                  }}
                                >
                                  <p
                                    style={{
                                      fontSize: "1rem",
                                      fontWeight: 500,
                                      color: "#AE0006",
                                      marginBottom: "8px",
                                    }}
                                  >
                                    Claim On-Hold Reason
                                  </p>
                                  <p
                                    style={{
                                      fontSize: "1rem",
                                      fontWeight: 400,
                                      color: "#252D38",
                                      overflowWrap: "break-word",
                                      wordBreak: "break-word",
                                      wordWrap: "break-word",
                                    }}
                                  >
                                    {row.remarks}
                                  </p>
                                </div>

                                <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={() => billSectionOpen(idx)}
                                  sx={{
                                    backgroundColor: "#0066DC",
                                    borderRadius: "8px",
                                    minWidth: { sm: "200px", xs: "100%" },
                                    textTransform: "none",
                                    float: "right",
                                    fontSize: "1rem",
                                    color: "#fff",
                                  }}
                                >
                                  Re-Submit Bill Details/Docs
                                </Button>
                              </div>
                              <div style={{ clear: "both" }}></div>
                            </div>
                            <br />
                          </div>
                        ))
                      ) : (
                        <></>
                      )}

                      {claimReportData.updatedBillRecord.length > 0 ? (
                        claimReportData.updatedBillRecord.map((row, idx) => (
                          <div key={idx}>
                            <h2
                              tabIndex={0}
                              style={{
                                fontSize: "1.25rem",
                                fontWeight: 500,
                                color: "#252D38",
                                marginBottom: "1.2rem",
                                overflowWrap: "break-word",
                              }}
                            >
                              {row.category} Bill Details
                            </h2>
                            <div
                              style={{
                                position: "relative",
                                border: "1px solid #DBE0E6",
                                borderRadius: "16px",
                                padding: "12px",
                                backgroundColor: "#ffffff",
                                boxShadow: "rgba(0, 0, 0, 0.1) 0px 1px 2px",
                              }}
                            >
                              <div
                                className="bill-status-badge"
                                style={{
                                  backgroundColor: "#FAFAFF",
                                  color: "#5E40AD",
                                }}
                              >
                                Bill Details Updated
                              </div>
                              <div
                                className="grid-container claim-details"
                                style={{ paddingTop: "32px" }}
                              >
                                <p tabIndex={"0"}>Bill No:</p>
                                <p tabIndex={"0"}>{row.billnumber}</p>

                                <p tabIndex={"0"}>Bill Date:</p>
                                <p tabIndex={"0"}>{row.billdate}</p>

                                <p tabIndex={"0"}>Bill Amount:</p>
                                <p tabIndex={"0"}>₹{row.billamount}.00</p>

                                <p tabIndex={"0"}>Hospital Name:</p>
                                <p tabIndex={"0"}>{row.hospitalname}</p>
                              </div>
                            </div>
                            <br />
                          </div>
                        ))
                      ) : (
                        <></>
                      )}

                      {apiFailure ? (
                        <p style={{ marginTop: "10px", color: "#FC1721" }}>
                          {apiFailure} &nbsp;
                        </p>
                      ) : (
                        <></>
                      )}
                      <br />
                      <br />
                      <br />
                      <br />
                    </div>
                    <Box
                      sx={{
                        position: "fixed",
                        bottom: 0,
                        left: 0,
                        right: 0,
                        backgroundColor: "#fff",
                        borderTop: "1px solid #E5E7EB",
                        padding: "16px",
                        zIndex: 1000,
                        boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      <Container
                        maxWidth="xl"
                        sx={{ padding: { xs: "0", lg: "0" } }}
                      >
                        <Grid container spacing={2}>
                          <Grid
                            item
                            xs={12}
                            lg={6}
                            sx={{ display: { xs: "none", lg: "block" } }}
                          >
                            <Button
                              variant="outlined"
                              fullWidth
                              onClick={() => navigate(-1)}
                              disabled={isSubmitting}
                              sx={{
                                color: "#47566A",
                                borderRadius: "8px",
                                border: "1px solid #A4B0C0",
                                fontSize: "16px",
                                fontWeight: 500,
                                height: "48px",
                                backgroundColor: "#fff",
                                "&:hover": {
                                  borderColor: "#A4B0C0",
                                  backgroundColor: "#fff",
                                },
                              }}
                            >
                              Cancel
                            </Button>
                          </Grid>
                          <Grid item xs={12} lg={6}>
                            <Button
                              variant="contained"
                              fullWidth
                              disabled={
                                isSubmitting ||
                                !(
                                  claimReportData.updatedBillRecord.length +
                                    claimReportData.billRecord.length ===
                                    claimReportData.updatedBillRecord.length &&
                                  (claimReportData.oldBankRecord.length === 0 ||
                                    claimReportData.updatedBankRecord.length >
                                      0)
                                )
                              }
                              startIcon={
                                isSubmitting ? (
                                  <CircularProgress size="1rem" />
                                ) : null
                              }
                              onClick={() => reSubmitClaim()}
                              sx={{
                                borderRadius: "8px",
                                fontSize: "16px",
                                fontWeight: 500,
                                color: "#fff",
                                height: { xs: "48px", lg: "48px" },
                                backgroundColor: "#0066DC",
                                "&:disabled": {
                                  backgroundColor: "#DBE0E6",
                                  color: "#8A99AD",
                                  border: "1px solid #BFC8D2",
                                },
                              }}
                            >
                              {isSubmitting
                                ? "Processing"
                                : "Submit Updated Claim"}
                            </Button>
                          </Grid>
                        </Grid>
                      </Container>
                    </Box>
                    <Box
                      sx={{
                        display: { xs: "block", lg: "none" },
                      }}
                    />
                  </>
                )}
              </Container>
            ) : (
              <Backdrop
                sx={{
                  color: "#fff",
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open
              >
                {loading ? (
                  <CircularProgress color="inherit" />
                ) : (
                  <p sx={{ color: "#212529" }}>
                    <strong> {message} </strong>
                  </p>
                )}
              </Backdrop>
            )}
            {!loading && (
              <div
                className="mobile-page-with-footer"
                style={{ paddingBottom: "120px" }}
              >
                <MobileSecurityFooter />
              </div>
            )}
          </Container>
        </>
      )}
    </main>
  );
}